(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('hospitalization-type-parent', {
            parent: 'entity',
            url: '/hospitalization-type-parent?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.hospitalizationTypeParent.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hospitalization-type-parent/hospitalization-type-parents.html',
                    controller: 'HospitalizationTypeParentController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hospitalizationTypeParent');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('hospitalization-type-parent-detail', {
            parent: 'entity',
            url: '/hospitalization-type-parent/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.hospitalizationTypeParent.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hospitalization-type-parent/hospitalization-type-parent-detail.html',
                    controller: 'HospitalizationTypeParentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hospitalizationTypeParent');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HospitalizationTypeParent', function($stateParams, HospitalizationTypeParent) {
                    return HospitalizationTypeParent.get({id : $stateParams.id});
                }]
            }
        })
        .state('hospitalization-type-parent.new', {
            parent: 'hospitalization-type-parent',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization-type-parent/hospitalization-type-parent-dialog.html',
                    controller: 'HospitalizationTypeParentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('hospitalization-type-parent', null, { reload: true });
                }, function() {
                    $state.go('hospitalization-type-parent');
                });
            }]
        })
        .state('hospitalization-type-parent.edit', {
            parent: 'hospitalization-type-parent',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization-type-parent/hospitalization-type-parent-dialog.html',
                    controller: 'HospitalizationTypeParentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HospitalizationTypeParent', function(HospitalizationTypeParent) {
                            return HospitalizationTypeParent.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('hospitalization-type-parent', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hospitalization-type-parent.delete', {
            parent: 'hospitalization-type-parent',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hospitalization-type-parent/hospitalization-type-parent-delete-dialog.html',
                    controller: 'HospitalizationTypeParentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HospitalizationTypeParent', function(HospitalizationTypeParent) {
                            return HospitalizationTypeParent.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('hospitalization-type-parent', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
